class LucidFaqCollapse extends HTMLElement {
  #body = null;
  #toggle = null;
  #label = null;
  #resizeObserver = null;

  connectedCallback() {
    this.#body = this.querySelector('[data-collapse-body]');
    this.#toggle = this.querySelector('[data-collapse-toggle]');
    this.#label = this.querySelector('[data-collapse-label]');
    if (!this.#body || !this.#toggle) return;

    this.#toggle.addEventListener('click', this.#onToggle);
    if ('ResizeObserver' in window) {
      this.#resizeObserver = new ResizeObserver(() => this.#measure());
      this.#resizeObserver.observe(this.#body);
    }
    this.#measure();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#toggle?.removeEventListener('click', this.#onToggle);
  }

  #measure() {
    if (this.classList.contains('is-expanded')) return;
    this.classList.remove('is-short');
    const overflowing = this.#body.scrollHeight - this.#body.clientHeight > 2;
    this.classList.toggle('is-short', !overflowing);
    this.#toggle.hidden = !overflowing;
  }

  #onToggle = () => {
    const expanded = !this.classList.contains('is-expanded');
    this.classList.toggle('is-expanded', expanded);
    this.#toggle.setAttribute('aria-expanded', String(expanded));
    if (this.#label) {
      this.#label.textContent = expanded ? this.#toggle.dataset.labelLess : this.#toggle.dataset.labelMore;
    }
    if (!expanded) this.#measure();
  };
}

if (!customElements.get('lucid-faq-collapse')) customElements.define('lucid-faq-collapse', LucidFaqCollapse);
